import Vue from 'vue';
import VueI18n from 'vue-i18n';
import dictionary from '../assets/Dictionary/index';

Vue.use(VueI18n);
export const i18n = new VueI18n({
	locale: 'de',
	fallbackLocale: 'en',
	messages: dictionary,
});
